import { LoginPage } from "@cavort/auth";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { z } from "zod";

// Both params are genuinely optional: a plain `navigate({ to: "/login" })`
// from the app shell or another auth page must not have to spell out
// `search`. An unrecognised value falls back to "absent" instead of failing
// the whole route.
const searchSchema = z.object({
	verified: z.enum(["success", "expired", "error"]).optional().catch(undefined),
	redirect: z.string().optional().catch(undefined),
});

export const Route = createFileRoute("/_auth/login")({
	validateSearch: searchSchema,
	component: LoginRoute,
});

function LoginRoute() {
	const { verified, redirect } = Route.useSearch();
	const navigate = useNavigate();

	return (
		<LoginPage
			verified={verified}
			redirect={redirect}
			onSuccess={() => navigate({ to: redirect ?? "/dashboard" })}
			onSignupClick={() => navigate({ to: "/signup" })}
			onResetPasswordClick={() => navigate({ to: "/forgot-password" })}
		/>
	);
}
